import { useState, useCallback } from 'react';
import { exportReportToCSV } from '../api/reportsApi';
import type { ExportOptions } from '../types/reportsApi';

export type { ExportOptions };

/**
 * React hook for exporting reports to CSV
 * Provides loading state, error handling, and export function
 */
export function useExportReport() {
    const [isExporting, setIsExporting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const exportReport = useCallback(async (
        reportKey: string,
        options: ExportOptions = {}
    ) => {
        setIsExporting(true);
        setError(null);

        try {
            await exportReportToCSV(reportKey, options);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Export failed';
            setError(errorMessage);
            throw err;
        } finally {
            setIsExporting(false);
        }
    }, []);

    const clearError = useCallback(() => {
        setError(null);
    }, []);

    return { exportReport, isExporting, error, clearError };
}

export default useExportReport;
